import React, { useEffect, useState } from 'react';
import { Col, Row, CaptionText } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

export default function Disclaimer(props) {
  const [content, setContent] = useState(null);

  useEffect(() => {
    setContent(props.content);
  }, []);

  if (isEmpty(content)) {
    return null;
  }

  return (
    <Row
      style={{
        maxWidth: '375px',
        marginLeft: 'auto',
        marginRight: 'auto',
      }}
    >
      <Col sm={12}>
        <CaptionText
          data-testid="disclaimer-content"
          className="legal-text"
          size="sm"
        >
          {content}
        </CaptionText>
      </Col>
    </Row>
  );
}

Disclaimer.propTypes = {
  content: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
};
